module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("您当前的浏览器不支持真相搜索应用")]), _vm._v(" "), _c('p', [_vm._v("请将您的浏览器升级至最新版本后重新访问（IE 浏览器需要升级到 IE9 及以上版本）。"), _c('br'), _vm._v("谢谢。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14721c3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/NotSupport.vue
// module id = 747
// module chunks = 1